// @flow
import { css } from "styled-components";
import { RichText } from "../../components/RichText/RichText";
import { media } from "../../media";
import { whiteSliceAdjacentSliceRules } from "../AdjacentSliceRules/AdjacentSliceRules";

const wrapper = css`
  ${whiteSliceAdjacentSliceRules}
  padding: 30px 20px;
  a {
    color: #2d89d9;
  }
  p {
    font-size: 18px;
    line-height: 27px;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  p {
    text-align: left;
  }
  ${media.tablet`
    padding: 40px 20px;
    margin: 0 auto;
    max-width: 533px;
    p {
      font-size: 20px;
      line-height: 30px;
    }
  `}
  ${media.desktop`
    width: calc((100% * 7 / 12) + 40px);
    padding: 50px 0px;
    max-width: 747px;
  `}
`;

export const CustomerStoriesBodyCopy = ({
  content,
}: {
  content: PrismicRichText,
}) => (
  <div className="optional-top-padding" css={wrapper}>
    <RichText left>{content}</RichText>
  </div>
);
